/* 
import cart from '@/constants/cart'
*/

let pid = [
  {
    id: '4011',
    __ZH: 'Eng-英语',
    lang: 'en',
  },
  {
    id: '4075',
    __ZH: 'Deu-德语',
    lang: 'de',
  },
  {
    id: '4073',
    __ZH: 'Espa-西语',
    lang: 'es',
  },
  {
    id: '4072',
    __ZH: 'Fran-法语',
    lang: 'fr',
  },
  {
    id: '4070',
    __ZH: 'ltal-意大利语',
    lang: 'it',
  },

  {
    id: '4068',
    __ZH: 'Port-葡语',
    lang: 'br',
  },
  {
    id: '4076',
    __ZH: 'Japan-日语',
    lang: 'jp',
  },
  {
    id: '4067',
    __ZH: 'Kore-韩语',
    lang: 'kr',
  },
  {
    id: '4069',
    __ZH: 'Arab-阿语',
    lang: 'ar',
  },
  {
    id: '4074',
    __ZH: 'Nede-荷兰语',
    lang: 'nl',
  },

  {
    id: '4078',
    __ZH: 'Indo-印尼语',
    lang: 'in',
  },
  {
    id: '4079',
    __ZH: 'India-印度语',
    lang: 'id',
  },
  {
    id: '4080',
    __ZH: 'Turk-土耳其语',
    lang: 'tr',
  },
  {
    id: '4071',
    __ZH: 'Russ-俄语',
    lang: 'ru',
  },
  {
    id: '5432',
    __ZH: 'Tail-泰语',
    lang: '',
  },

  {
    id: '4077',
    __ZH: 'TChi-中繁',
    lang: 'tw',
  },
  {
    id: '5431',
    __ZH: 'SChi-中简',
    lang: 'cn',
  },
];

export default pid;
